var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBorder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 587.088,
    height: 485.734,
    viewBox: "0 0 587.088 485.734",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "border",
    transform: "translate(-712.769 -241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5846",
    "data-name": "Group 5846",
    transform: "translate(964.295 -178.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5843",
    "data-name": "Group 5843",
    transform: "translate(256.474 419.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5841",
    "data-name": "Group 5841",
    transform: "translate(59.756 4.693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9742",
    "data-name": "Path 9742",
    d: "M386.136,450.719c-3.159-.044-4.483-3.029-2.835-5.649,1.384-2.2,4.527-2.506,6.773-1.736a5.483,5.483,0,0,1,3.138,7.11c-1.03,2.761-4.292,4.359-7.078,4.48a12.727,12.727,0,0,1-8.787-2.821c-2.994-2.551-3.422-7.338-2.951-10.96.937-7.226,6.828-11.672,13.782-12.486,1.306-.152.476.74-.34.836a12.787,12.787,0,0,0-10.9,8.455c-1.654,5-1.163,11.889,3.869,14.742,2.238,1.269,5.454,1.959,7.855.843a5.369,5.369,0,0,0,2.9-5.992c-.405-2.11-3.063-4.539-5.345-3.573-2.551,1.079-2.394,5.848.726,5.891,1.246.017-.223.867-.806.859Z",
    transform: "translate(-374.233 -428.64)",
    fill: "#FFAF42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5842",
    "data-name": "Group 5842",
    transform: "translate(48.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9743",
    "data-name": "Path 9743",
    d: "M355.424,426.821c.042,3.16,3.029,4.484,5.649,2.835,2.2-1.384,2.506-4.527,1.736-6.773a5.485,5.485,0,0,0-7.111-3.139c-2.76,1.031-4.359,4.293-4.48,7.079a12.721,12.721,0,0,0,2.82,8.786c2.55,2.995,7.339,3.423,10.96,2.952,7.226-.938,11.672-6.828,12.485-13.782.152-1.307-.74-.478-.836.339a12.786,12.786,0,0,1-8.455,10.9c-5,1.654-11.889,1.163-14.742-3.868-1.269-2.238-1.96-5.454-.844-7.855a5.371,5.371,0,0,1,5.993-2.9c2.11.405,4.539,3.063,3.573,5.345-1.079,2.551-5.849,2.394-5.892-.726-.016-1.245-.866.223-.858.806Z",
    transform: "translate(-351.206 -419.392)",
    fill: "#FFAF42"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9744",
    "data-name": "Path 9744",
    d: "M256.734,425.911s13.252-.055,17.849-.053c4.963,0,10.214-.246,14.927.786a17.625,17.625,0,0,0,13.37-2.054c1.228-.74,1.028-1.327-.28-.911-3.1,1.256-8.078,1.587-13.11,1.24a145.712,145.712,0,0,0-15.21.1c-4.594.2-17.575.2-17.575.2C256.09,425.243,255.987,425.943,256.734,425.911Z",
    transform: "translate(-256.474 -421.436)",
    fill: "#FFAF42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5844",
    "data-name": "Group 5844",
    transform: "translate(282.118 426.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9747",
    "data-name": "Path 9747",
    d: "M322.9,448.1a2.99,2.99,0,0,0-2.329-4.871c-2.146-.192-3.913,1.8-4.522,3.739a4.752,4.752,0,0,0,3.145,5.837c2.342.726,5.024-.681,6.493-2.526A11.167,11.167,0,0,0,328.2,442.8c-.2-3.374-3.156-6.149-5.788-7.7-5.252-3.105-11.13-1.375-15.131,2.967-.752.814.253.71.723.2a10.323,10.323,0,0,1,11.027-3.083c4.137,1.461,8.452,5.369,7.834,10.295-.274,2.19-1.418,4.752-3.353,5.818a4.349,4.349,0,0,1-5.412-1.12c-1.2-1.372-1.479-4.452.295-5.515,1.986-1.187,5.066,1.393,3.54,3.553-.609.861.685.3.97-.108Z",
    transform: "translate(-307.009 -433.516)",
    fill: "#FFAF42"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9748",
    "data-name": "Path 9748",
    d: "M401.055,530.1s.012-12.9.009-17.495c0-4.963.225-10.328-.806-15.04a17.627,17.627,0,0,1,2.053-13.371c.74-1.227,1.327-1.027.911.281-1.256,3.1-1.588,8.078-1.24,13.111a147.812,147.812,0,0,1-.075,15.323c-.2,4.593-.157,17.221-.157,17.221C401.722,530.743,401.024,530.847,401.055,530.1Z",
    transform: "translate(-70.581 -31.516)",
    fill: "#FFAF42"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5845",
    "data-name": "Group 5845",
    transform: "translate(308.232 452.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9749",
    "data-name": "Path 9749",
    d: "M363.371,489.428a2.991,2.991,0,0,1,4.871,2.33c.191,2.145-1.8,3.913-3.739,4.522a4.753,4.753,0,0,1-5.837-3.146c-.725-2.342.681-5.024,2.526-6.492a11.162,11.162,0,0,1,7.482-2.509c3.373.2,6.148,3.157,7.7,5.788,3.105,5.25,1.375,11.129-2.967,15.131-.815.751-.71-.253-.2-.723a10.327,10.327,0,0,0,3.083-11.028c-1.461-4.137-5.369-8.452-10.295-7.834-2.191.273-4.752,1.417-5.819,3.353a4.352,4.352,0,0,0,1.121,5.412c1.373,1.2,4.452,1.48,5.516-.295,1.187-1.986-1.394-5.065-3.553-3.541-.861.609-.3-.684.108-.97Z",
    transform: "translate(-358.472 -484.118)",
    fill: "#FFAF42"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5849",
    "data-name": "Group 5849",
    transform: "translate(1220.769 647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5843-2",
    "data-name": "Group 5843",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5841-2",
    "data-name": "Group 5841",
    transform: "translate(59.756 48.745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9742-2",
    "data-name": "Path 9742",
    d: "M386.136,432.858c-3.159.044-4.483,3.029-2.835,5.649,1.384,2.2,4.527,2.506,6.773,1.736a5.483,5.483,0,0,0,3.138-7.11c-1.03-2.761-4.292-4.359-7.078-4.48a12.727,12.727,0,0,0-8.787,2.821c-2.994,2.551-3.422,7.338-2.951,10.96.937,7.226,6.828,11.672,13.782,12.486,1.306.152.476-.74-.34-.836a12.787,12.787,0,0,1-10.9-8.455c-1.654-5-1.163-11.889,3.869-14.742,2.238-1.269,5.454-1.959,7.855-.843a5.369,5.369,0,0,1,2.9,5.992c-.405,2.11-3.063,4.539-5.345,3.573-2.551-1.079-2.394-5.848.726-5.891,1.246-.017-.223-.867-.806-.859Z",
    transform: "translate(-374.233 -428.64)",
    fill: "#FFAF42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5842-2",
    "data-name": "Group 5842",
    transform: "translate(48.071 60.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9743-2",
    "data-name": "Path 9743",
    d: "M355.424,431.3c.042-3.16,3.029-4.484,5.649-2.835,2.2,1.384,2.506,4.527,1.736,6.773a5.485,5.485,0,0,1-7.111,3.139c-2.76-1.031-4.359-4.293-4.48-7.079a12.721,12.721,0,0,1,2.82-8.786c2.55-2.995,7.339-3.423,10.96-2.952,7.226.938,11.672,6.828,12.485,13.782.152,1.307-.74.478-.836-.339a12.786,12.786,0,0,0-8.455-10.9c-5-1.654-11.889-1.163-14.742,3.868-1.269,2.238-1.96,5.454-.844,7.855a5.371,5.371,0,0,0,5.993,2.9c2.11-.405,4.539-3.063,3.573-5.345-1.079-2.551-5.849-2.394-5.892.726-.016,1.245-.866-.223-.858-.806Z",
    transform: "translate(-351.206 -419.392)",
    fill: "#FFAF42"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9744-2",
    "data-name": "Path 9744",
    d: "M257.409,424.785s12.559.12,17.157.117c4.963,0,10.231.159,14.945-.872a17.625,17.625,0,0,1,13.37,2.054c1.228.74,1.028,1.327-.28.911-3.1-1.256-8.078-1.587-13.11-1.24a146.38,146.38,0,0,1-15.228-.01c-4.594-.2-16.883-.266-16.883-.266C256.765,425.453,256.662,424.753,257.409,424.785Z",
    transform: "translate(-256.474 -349.504)",
    fill: "#FFAF42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5844-2",
    "data-name": "Group 5844",
    transform: "translate(25.643 53.082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9747-2",
    "data-name": "Path 9747",
    d: "M322.9,438.415a2.99,2.99,0,0,1-2.329,4.871c-2.146.192-3.913-1.8-4.522-3.739a4.752,4.752,0,0,1,3.145-5.837c2.342-.726,5.024.681,6.493,2.526a11.167,11.167,0,0,1,2.508,7.482c-.2,3.374-3.156,6.149-5.788,7.7-5.252,3.105-11.13,1.375-15.131-2.967-.752-.814.253-.71.723-.2a10.323,10.323,0,0,0,11.027,3.083c4.137-1.461,8.452-5.369,7.834-10.295-.274-2.19-1.418-4.752-3.353-5.818a4.349,4.349,0,0,0-5.412,1.12c-1.2,1.372-1.479,4.452.295,5.515,1.986,1.187,5.066-1.393,3.54-3.553-.609-.861.685-.3.97.108Z",
    transform: "translate(-307.009 -433.516)",
    fill: "#FFAF42"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9748-2",
    "data-name": "Path 9748",
    d: "M401.031,483.366s.115,13.412.112,18.011c0,4.963.146,10.322-.886,15.034a17.627,17.627,0,0,0,2.053,13.371c.74,1.227,1.327,1.027.911-.281-1.256-3.1-1.588-8.078-1.24-13.111a148.01,148.01,0,0,0,0-15.317c-.2-4.593-.26-17.737-.26-17.737C401.7,482.722,401,482.619,401.031,483.366Z",
    transform: "translate(-327.055 -483.334)",
    fill: "#FFAF42"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5845-2",
    "data-name": "Group 5845",
    transform: "translate(51.758 25.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9749-2",
    "data-name": "Path 9749",
    d: "M363.371,500.013a2.991,2.991,0,0,0,4.871-2.33c.191-2.145-1.8-3.913-3.739-4.522a4.753,4.753,0,0,0-5.837,3.146c-.725,2.342.681,5.024,2.526,6.492a11.162,11.162,0,0,0,7.482,2.509c3.373-.2,6.148-3.157,7.7-5.788,3.105-5.25,1.375-11.129-2.967-15.131-.815-.751-.71.253-.2.723a10.327,10.327,0,0,1,3.083,11.028c-1.461,4.137-5.369,8.452-10.295,7.834-2.191-.273-4.752-1.417-5.819-3.353a4.352,4.352,0,0,1,1.121-5.412c1.373-1.2,4.452-1.48,5.516.295,1.187,1.986-1.394,5.065-3.553,3.541-.861-.609-.3.684.108.97Z",
    transform: "translate(-358.472 -484.118)",
    fill: "#FFAF42"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5847",
    "data-name": "Group 5847",
    transform: "translate(712.769 241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5843-3",
    "data-name": "Group 5843",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5841-3",
    "data-name": "Group 5841",
    transform: "translate(0 4.693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9742-3",
    "data-name": "Path 9742",
    d: "M381.663,450.719c3.159-.044,4.483-3.029,2.835-5.649-1.384-2.2-4.527-2.506-6.773-1.736a5.483,5.483,0,0,0-3.138,7.11c1.03,2.761,4.292,4.359,7.078,4.48a12.727,12.727,0,0,0,8.787-2.821c2.994-2.551,3.422-7.338,2.951-10.96-.937-7.226-6.828-11.672-13.782-12.486-1.306-.152-.476.74.34.836a12.787,12.787,0,0,1,10.9,8.455c1.654,5,1.163,11.889-3.869,14.742-2.238,1.269-5.454,1.959-7.855.843a5.369,5.369,0,0,1-2.9-5.992c.405-2.11,3.063-4.539,5.345-3.573,2.551,1.079,2.394,5.848-.726,5.891-1.246.017.223.867.806.859Z",
    transform: "translate(-374.233 -428.64)",
    fill: "#FFAF42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5842-3",
    "data-name": "Group 5842",
    transform: "translate(4.721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9743-3",
    "data-name": "Path 9743",
    d: "M373.284,426.821c-.042,3.16-3.029,4.484-5.649,2.835-2.2-1.384-2.506-4.527-1.736-6.773a5.485,5.485,0,0,1,7.111-3.139c2.76,1.031,4.359,4.293,4.48,7.079a12.721,12.721,0,0,1-2.82,8.786c-2.55,2.995-7.339,3.423-10.96,2.952-7.226-.938-11.672-6.828-12.485-13.782-.152-1.307.74-.478.836.339a12.786,12.786,0,0,0,8.455,10.9c5,1.654,11.889,1.163,14.742-3.868,1.269-2.238,1.96-5.454.844-7.855a5.371,5.371,0,0,0-5.993-2.9c-2.11.405-4.539,3.063-3.573,5.345,1.079,2.551,5.849,2.394,5.892-.726.016-1.245.866.223.858.806Z",
    transform: "translate(-351.206 -419.392)",
    fill: "#FFAF42"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9744-3",
    "data-name": "Path 9744",
    d: "M303.2,425.876s-12.923.146-17.521.149c-4.963,0-10.3-.412-15.01.619a17.626,17.626,0,0,1-13.37-2.054c-1.228-.74-1.028-1.327.28-.911,3.1,1.256,8.078,1.587,13.11,1.24a146.7,146.7,0,0,1,15.294.263c4.594.2,17.247,0,17.247,0C303.839,425.208,303.942,425.908,303.2,425.876Z",
    transform: "translate(-224.612 -421.436)",
    fill: "#FFAF42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5844-3",
    "data-name": "Group 5844",
    transform: "translate(32.239 7.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9747-3",
    "data-name": "Path 9747",
    d: "M312.32,448.1a2.99,2.99,0,0,1,2.329-4.871c2.146-.192,3.913,1.8,4.522,3.739a4.752,4.752,0,0,1-3.145,5.837c-2.342.726-5.024-.681-6.493-2.526a11.167,11.167,0,0,1-2.508-7.482c.2-3.374,3.156-6.149,5.788-7.7,5.252-3.105,11.13-1.375,15.131,2.967.752.814-.253.71-.723.2a10.323,10.323,0,0,0-11.027-3.083c-4.137,1.461-8.452,5.369-7.834,10.295.274,2.19,1.418,4.752,3.353,5.818a4.349,4.349,0,0,0,5.412-1.12c1.2-1.372,1.479-4.452-.295-5.515-1.986-1.187-5.066,1.393-3.54,3.553.609.861-.685.3-.97-.108Z",
    transform: "translate(-307.009 -433.516)",
    fill: "#FFAF42"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9748-3",
    "data-name": "Path 9748",
    d: "M402.073,530.1s-.045-12.854-.042-17.452c0-4.963-.191-10.371.84-15.083a17.627,17.627,0,0,0-2.053-13.371c-.74-1.227-1.327-1.027-.911.281,1.256,3.1,1.588,8.078,1.24,13.111a148.766,148.766,0,0,0,.042,15.366c.2,4.593.191,17.179.191,17.179C401.405,530.744,402.1,530.847,402.073,530.1Z",
    transform: "translate(-396.985 -450.907)",
    fill: "#FFAF42"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5845-3",
    "data-name": "Group 5845",
    transform: "translate(7.844 32.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9749-3",
    "data-name": "Path 9749",
    d: "M373.059,489.428a2.991,2.991,0,0,0-4.871,2.33c-.191,2.145,1.8,3.913,3.739,4.522a4.753,4.753,0,0,0,5.837-3.146c.725-2.342-.681-5.024-2.526-6.492a11.162,11.162,0,0,0-7.482-2.509c-3.373.2-6.148,3.157-7.7,5.788-3.105,5.25-1.375,11.129,2.967,15.131.815.751.71-.253.2-.723a10.327,10.327,0,0,1-3.083-11.028c1.461-4.137,5.369-8.452,10.295-7.834,2.191.273,4.752,1.417,5.819,3.353a4.352,4.352,0,0,1-1.121,5.412c-1.373,1.2-4.452,1.48-5.516-.295-1.187-1.986,1.394-5.065,3.553-3.541.861.609.3-.684-.108-.97Z",
    transform: "translate(-358.472 -484.118)",
    fill: "#FFAF42"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5848",
    "data-name": "Group 5848",
    transform: "translate(712.769 647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5843-4",
    "data-name": "Group 5843",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5841-4",
    "data-name": "Group 5841",
    transform: "translate(0 48.745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9742-4",
    "data-name": "Path 9742",
    d: "M381.663,432.858c3.159.044,4.483,3.029,2.835,5.649-1.384,2.2-4.527,2.506-6.773,1.736a5.483,5.483,0,0,1-3.138-7.11c1.03-2.761,4.292-4.359,7.078-4.48a12.727,12.727,0,0,1,8.787,2.821c2.994,2.551,3.422,7.338,2.951,10.96-.937,7.226-6.828,11.672-13.782,12.486-1.306.152-.476-.74.34-.836a12.787,12.787,0,0,0,10.9-8.455c1.654-5,1.163-11.889-3.869-14.742-2.238-1.269-5.454-1.959-7.855-.843a5.369,5.369,0,0,0-2.9,5.992c.405,2.11,3.063,4.539,5.345,3.573,2.551-1.079,2.394-5.848-.726-5.891-1.246-.017.223-.867.806-.859Z",
    transform: "translate(-374.233 -428.64)",
    fill: "#FFAF42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5842-4",
    "data-name": "Group 5842",
    transform: "translate(4.721 60.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9743-4",
    "data-name": "Path 9743",
    d: "M373.284,431.3c-.042-3.16-3.029-4.484-5.649-2.835-2.2,1.384-2.506,4.527-1.736,6.773a5.485,5.485,0,0,0,7.111,3.139c2.76-1.031,4.359-4.293,4.48-7.079a12.721,12.721,0,0,0-2.82-8.786c-2.55-2.995-7.339-3.423-10.96-2.952-7.226.938-11.672,6.828-12.485,13.782-.152,1.307.74.478.836-.339a12.786,12.786,0,0,1,8.455-10.9c5-1.654,11.889-1.163,14.742,3.868,1.269,2.238,1.96,5.454.844,7.855a5.371,5.371,0,0,1-5.993,2.9c-2.11-.405-4.539-3.063-3.573-5.345,1.079-2.551,5.849-2.394,5.892.726.016,1.245.866-.223.858-.806Z",
    transform: "translate(-351.206 -419.392)",
    fill: "#FFAF42"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9744-4",
    "data-name": "Path 9744",
    d: "M303.267,424.755s-13.032.257-17.63.254c-4.963,0-10.26.053-14.973-.979a17.626,17.626,0,0,0-13.37,2.054c-1.228.74-1.028,1.327.28.911,3.1-1.256,8.078-1.587,13.11-1.24a147.364,147.364,0,0,0,15.256.1c4.594-.2,17.356-.4,17.356-.4C303.911,425.423,304.014,424.723,303.267,424.755Z",
    transform: "translate(-224.612 -349.504)",
    fill: "#FFAF42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5844-4",
    "data-name": "Group 5844",
    transform: "translate(32.239 53.082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9747-4",
    "data-name": "Path 9747",
    d: "M312.32,438.415a2.99,2.99,0,0,0,2.329,4.871c2.146.192,3.913-1.8,4.522-3.739a4.752,4.752,0,0,0-3.145-5.837c-2.342-.726-5.024.681-6.493,2.526a11.167,11.167,0,0,0-2.508,7.482c.2,3.374,3.156,6.149,5.788,7.7,5.252,3.105,11.13,1.375,15.131-2.967.752-.814-.253-.71-.723-.2a10.323,10.323,0,0,1-11.027,3.083c-4.137-1.461-8.452-5.369-7.834-10.295.274-2.19,1.418-4.752,3.353-5.818a4.349,4.349,0,0,1,5.412,1.12c1.2,1.372,1.479,4.452-.295,5.515-1.986,1.187-5.066-1.393-3.54-3.553.609-.861-.685-.3-.97.108Z",
    transform: "translate(-307.009 -433.516)",
    fill: "#FFAF42"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9748-4",
    "data-name": "Path 9748",
    d: "M402.065,483.807s.146,13.029.148,17.627c0,4.963-.374,10.265.658,14.977a17.627,17.627,0,0,1-2.053,13.371c-.74,1.227-1.327,1.027-.911-.281,1.256-3.1,1.588-8.078,1.24-13.111a146.056,146.056,0,0,1,.224-15.26c.2-4.593-.006-17.085-.006-17.085C401.391,483.432,402.1,483.06,402.065,483.807Z",
    transform: "translate(-396.985 -483.334)",
    fill: "#FFAF42"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5845-4",
    "data-name": "Group 5845",
    transform: "translate(7.844 25.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9749-4",
    "data-name": "Path 9749",
    d: "M373.059,500.013a2.991,2.991,0,0,1-4.871-2.33c-.191-2.145,1.8-3.913,3.739-4.522a4.753,4.753,0,0,1,5.837,3.146c.725,2.342-.681,5.024-2.526,6.492a11.162,11.162,0,0,1-7.482,2.509c-3.373-.2-6.148-3.157-7.7-5.788-3.105-5.25-1.375-11.129,2.967-15.131.815-.751.71.253.2.723a10.327,10.327,0,0,0-3.083,11.028c1.461,4.137,5.369,8.452,10.295,7.834,2.191-.273,4.752-1.417,5.819-3.353a4.352,4.352,0,0,0-1.121-5.412c-1.373-1.2-4.452-1.48-5.516.295-1.187,1.986,1.394,5.065,3.553,3.541.861-.609.3.684-.108.97Z",
    transform: "translate(-358.472 -484.118)",
    fill: "#FFAF42"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    y2: 331,
    transform: "translate(717.5 317.5)",
    fill: "none",
    stroke: "#FFAF42",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    y2: 331,
    transform: "translate(1295.1 319.5)",
    fill: "none",
    stroke: "#FFAF42",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9750",
    "data-name": "Path 9750",
    d: "M.025-100.859,0,329.633",
    transform: "translate(1121 245.1) rotate(90)",
    fill: "none",
    stroke: "#FFAF42",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9751",
    "data-name": "Path 9751",
    d: "M.025-100.859,0,329.633",
    transform: "translate(1121 722.604) rotate(90)",
    fill: "none",
    stroke: "#FFAF42",
    strokeWidth: 0.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorder);
export default __webpack_public_path__ + "static/media/border.9d409dbffdba7aa5fd8403df1f60b455.svg";
export { ForwardRef as ReactComponent };